<script setup>
const props = defineProps({
    backUrl: String,
})

if (window.location.hash) {
    const hashData = window.location.hash.substring(1);

    window.location.href = `${window.location.origin}/login?${hashData}&backUrl=${props.backUrl}`;
}
</script>

<template>
    <div class="flex items-center justify-center min-h-screen">
        <svg
            class="w-16 h-16 animate-spin"
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                class="text-gray-300 stroke-current"
                cx="25"
                cy="25"
                r="20"
                stroke="currentColor"
                stroke-width="5"
                fill="none"
            />
            <circle
                class="text-blue-500 stroke-current"
                cx="25"
                cy="25"
                r="20"
                stroke="currentColor"
                stroke-width="5"
                stroke-dasharray="125"
                stroke-dashoffset="75"
                fill="none"
            />
        </svg>
    </div>
</template>

